import { TFunction } from 'i18next';

import { RoleSpecialtyOption } from './types';

/** Stable identity used for de-dupe and React keys. */
export function roleSpecialtyKey(v: RoleSpecialtyOption): string {
    return `${ v.role?.id ?? 'none' }:${ v.specialty?.id ?? 'none' }`;
}

/** Human label; a null side renders as the translated "Any role" / "Any speciality". */
export function roleSpecialtyLabel(v: RoleSpecialtyOption, t: TFunction): string {
    return `${ v.role?.name ?? t('rolesSpecialtiesSelector:anyRole') } · ${ v.specialty?.name ?? t('rolesSpecialtiesSelector:anySpecialty') }`;
}
